import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_CONSULTATION } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// ✅ AsyncThunk to fetch consultation details
export const fetchConsultationReducer = createAsyncThunk(
  ACTION_CONSULTATION.fetch_consultation,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getConsultation}`,
      );
      console.log("response:", response.data.data);
      return response.data.data;
      // ✅ Handle success
      // if (response?.data?.status === true || response?.status === 200) {
      //   toast.success("Consultation data fetched successfully!");
      //   return response.data;
      // } else {
      //   const errMsg = response?.data?.message || "Failed to fetch consultation data.";
      //   toast.error(errMsg);
      //   return rejectWithValue(errMsg);
      // }
    } catch (error) {
      console.error("Error fetching consultation data:", error);
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingConsultationData");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
